function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M8.0180521,13.6769914 L3.66077359,15.9263026 C3.41611482,16.0526002 3.24857174,15.9301932 3.28535158,15.661689 L3.97921022,10.5963057 L0.595102215,6.94076116 C0.405086429,6.73550436 0.477530567,6.52797002 0.737470555,6.48075157 L5.52191055,5.61165155 L7.79653619,1.08549753 C7.91887605,0.842060087 8.11899538,0.845576595 8.23956802,1.08549753 L10.5141937,5.61165155 L15.2986337,6.48075157 C15.5672773,6.52955105 15.6342902,6.73196951 15.441002,6.94076116 L12.056894,10.5963057 L12.7507526,15.661689 C12.7880715,15.9341286 12.6120628,16.0485084 12.3753306,15.9263026 L8.0180521,13.6769914 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    className: "icon",
    style: {
      "height": "1em",
      "width": "0.94118em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/star.08ff2e0a.svg";
export { SvgComponent as ReactComponent };